<template>
    <div id="edit" class="ui segment" v-if="partition.identity">
        <h1 class="ui header">
            {{ $t('ui.page_titles.edit_provider_partition') }}
        </h1>
        <div class="ui divider"></div>
        <div class="ui form">
            <div class="ui grid" style="margin-top:0;margin-bottom:0">
                <div class="six wide red field" data-column="name">
                    <label>{{ $t('models.attributes.partitions.name') }}</label>
                    <input type="text" v-model="partition.name">
                </div>
                <div class="five wide red field">
                    <label>{{ $t('models.attributes.partitions.numbers_from') }}</label>
                    <input v-if="partition.count_of_core_waybills > 0" type="text" :value="partition.numbers_from" disabled>
                    <input v-else type="text" v-model="partition.numbers_from">
                </div>
                <div class="five wide red field">
                    <label>{{ $t('models.attributes.partitions.numbers_to') }}</label>
                    <input v-if="partition.count_of_core_waybills > 0" type="text" :value="partition.numbers_to" disabled>
                    <input v-else type="text" v-model="partition.numbers_to">
                </div>
                <div class="eight wide red field" v-if="current_customer">
                    <label>{{ $t('models.attributes.partitions.customer') }}</label>
                    <input :value="current_customer.company_short_name" disabled>
                </div>
                <div class="eight wide red field" v-else>
                    <label>{{ $t('models.attributes.partitions.customer') }}</label>
                    <input :value="$t('ui.general.no')" disabled>
                </div>
                <div class="eight wide red field">
                    <label>{{ $t('models.attributes.partitions.contracts') }}</label>
                    <select @change="$forceUpdate()" class="ui dropdown partition_type" v-if="current_customer" v-dropdown v-model="partition.contract_ids" multiple disabled>
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="contract in current_customer.contracts" :value="contract.identity">{{ contract.name }}</option>
                    </select>
                </div>
                <div class="eight wide red field" data-column="material_identity">
                    <label>
                        {{ $t('models.attributes.partitions.material') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.material_identity"
                            @click="clear_dropdown('.ui.dropdown.material_identity')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" v-if="current_store.customers" class="ui dropdown material_identity" v-dropdown v-model="partition.material_identity">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="material in current_store.materials" :value="material.identity">{{ material.name }}</option>
                    </select>
                    <div v-else class="ui inline active loader"></div>
                </div>
                <div class="eight wide red field">
                    <label>
                        {{ $t('models.attributes.partitions.label_type') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.label_type"
                            @click="clear_dropdown('.ui.dropdown.label_type')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" class="ui dropdown label_type" v-dropdown v-model="partition.label_type">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option value="Label::Default">TW568預設</option>
                        <option value="Label::ByExpress" v-if="$store.state.provider.node.code == 'BY'">博宇速運</option>
                        <option value="Label::ChangQing" v-if="$store.state.provider.node.code == 'CQF'">長慶運通</option>
                        <option value="Label::FlyCargo" v-if="$store.state.provider.node.code == 'FR'">飛樂航空</option>
                        <option value="Label::HCT">新竹物流</option>
                        <option value="Label::TCat">統一速達</option>
                        <option value="Label::Pelican">宅配通</option>
                        <option value="Label::Presco">統一超商(統一數網)</option>
                        <option value="Label::PrescoInvoice">統一超商含發票(統一數網)</option>
                        <option value="Label::FamilyMart">全家便利商店(日翊文化)</option>
                        <option value="Label::FamilyMartInvoice">全家便利商店含發票(日翊文化)</option>
                    </select>
                </div>

                <div class="eight wide red field">
                    <label>
                        {{ $t('models.attributes.partitions.numbers_rule') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.numbers_rule"
                            @click="clear_dropdown('.ui.dropdown.numbers_rule')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" class="ui dropdown numbers_rule" v-dropdown v-model="partition.numbers_rule">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option value="tcat_numbers_rule">黑貓檢查碼</option>
                        <option value="hct_numbers_rule">新竹檢查碼</option>
                        <option value="pelican_numbers_rule">宅配通檢查碼</option>
                    </select>
                </div>

                <div class="eight wide red field">
                    <label>
                        {{ $t('models.attributes.partitions.partition_type') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.partition_type"
                            @click="clear_dropdown('.ui.dropdown.partition_type')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" class="ui dropdown partition_type" v-dropdown v-model="partition.partition_type">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option value="Manual">手動取號</option>
                        <option value="Auto">自動取號</option>
                        <option value="Group">區間群組</option>
                    </select>
                </div>

                <div class="eight wide red field" data-column="note">
                    <label>{{ $t('models.attributes.partitions.note') }}</label>
                    <textarea v-model="partition.note" rows="4"></textarea>
                </div>

                <div class="eight wide red field">
                    <label>
                        <!-- 統計 -->
                        {{ $t('ui.pages.partitions.statistics') }}
                    </label>
                    <!-- 起始 -->
                    {{ $t('models.attributes.partitions.numbers_from') }}：{{ partition.numbers_from }}<br>
                    <!-- 結尾 -->
                    {{ $t('models.attributes.partitions.numbers_to') }}：{{ partition.numbers_to }}<br>
                    <!-- 總數量 -->
                    {{ $t('ui.pages.partitions.total_amount') }}：{{ number_with_commas(partition.numbers_amount) }}<br>
                    <!-- 可用數量 -->
                    {{ $t('ui.pages.partitions.available_quantity') }}：{{ number_with_commas(partition.remaining_numbers) }}
                </div>
            </div>

            <div class="ui negative message" v-for="(trial_error, key, index) in trial_errors">
                <h3>{{ $t("models.attributes.partitions." + key) }}</h3>
                <ul>
                    <li v-for="error in trial_error">{{ error }}</li>
                </ul>
            </div>

            <div class="ui positive message" v-if="trialed_partition && !trial_errors && !is_trialling">
                <h2>
                    <!-- 驗證結果 -->
                    {{ $t('ui.general.verify') }}
                    {{ $t('ui.general.result') }}
                </h2>
                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 起始： -->
                    {{ $t('models.attributes.partitions.numbers_from') }}：
                </span>
                {{ trialed_partition.numbers_from }}<br>

                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 結尾： -->
                    {{ $t('models.attributes.partitions.numbers_to') }}：
                </span>
                {{ trialed_partition.numbers_to }}<br>

                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 總數量： -->
                    {{ $t('ui.pages.partitions.total_amount') }}：
                </span>
                {{ number_with_commas(trialed_partition.numbers_amount) }}<br>

                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 可用數量： -->
                    {{ $t('ui.pages.partitions.available_quantity') }}：
                </span>
                {{ number_with_commas(trialed_partition.remaining_numbers) }}
            </div>

            <div class="ui divider"></div>

            <div class="ui buttons">
                <router-link :to="{name: 'provider_partitions'}" class="ui button">
                    {{ $t('ui.general.back') }}
                </router-link>
                <div class="or"></div>
                <a href="#" v-if="!is_trialling" @click.prevent="trial_partition()" class="ui orange button">
                    <!-- 驗證 -->
                    {{ $t('ui.general.verify') }}
                </a>
                <a href="#" v-else class="ui orange button">
                    <!-- 驗證中... -->
                    {{ $t('ui.general.verifying') }}...
                </a>
                <div class="or"></div>
                <a href="#" v-if="!is_loading" @click.prevent="update_partition()" class="ui blue button">{{ $t('ui.general.update') }}</a>
                <a href="#" v-else class="ui blue button">
                    {{ $t('ui.general.updating') }}...
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import FileUploader from "@toolbox/file_uploader/main.vue"
import Validator from '@toolbox/validator/main.js';

export default {
    name: "EditPartition",
    mixins: [
        Validator
    ],
    props: {
    },
    data() {
        return {
            is_loading: false,
            partition: {},
            is_trialling: false,
            trialed_partition: null,
            trial_errors: null
        }
    },
    watch: {

    },
    mounted() {
        this.fetch_partition();
    },
    methods: {
        clear_dropdown(selector = "") {
            this.partition.customer_identity = null;
            $(selector).dropdown('clear');
        },
        number_with_commas(number) {
            if (number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return 'N/A';
            }
        },
        fetch_partition() {
            let url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partition).parse({
                "partition_identity": this.$route.params.partition_identity,
            });

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.partition = response.data.partition
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        },
        trial_partition() {
            this.trial_errors = null;
            if (this.valid()) {
                this.is_trialling = true;

                let params = this.partition;
                let url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partition_trial).parse(
                    {
                        partition_identity: this.partition.identity
                    }
                );

                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.trialed_partition = response.data.partition;
                            this.is_trialling = false;
                        } else {
                            this.trial_errors = response.data.errors;
                            // this.$noty.error("驗證號碼區間失敗");
                            this.$noty.error(
                                this.$t('ui.notifications.error.verify__name', {
                                    name: this.$t('models.partitions'),
                                })
                            );
                            this.is_trialling = false;
                            Promise.reject();
                        }
                    })
                    .catch(error => {
                        // this.$noty.error("驗證號碼區間錯誤");
                        this.$noty.error(
                            this.$t('ui.general.verify') + ' ' +
                            this.$t('partition') + ' ' +
                            this.$t('ui.general.error')
                        );
                        this.is_trialling = false;
                    });
            }
        },
        async update_partition() {
            if (this.valid()) {
                await this.trial_partition();
                this.is_loading = true;

                let params = this.partition;
                let url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partition_update).parse(
                    {
                        partition_identity: this.partition.identity
                    }
                );

                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            // this.$noty.success("更新號碼區間成功");
                            this.$store.commit('provider/partitions_module/update_partition', response.data.partition);
                            this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "partitions");

                            this.$noty.success(
                                this.$t('ui.notifications.success.update__name', {
                                    name: this.$t('models.partitions')
                                })
                            );
                            this.$router.push('/provider/partitions');
                            this.is_loading = false;
                        } else {
                            // this.$noty.error("更新號碼區間失敗");
                            this.$noty.error(
                                this.$t('ui.notifications.error.update__name', {
                                    name: this.$t('models.partitions')
                                })
                            );
                            this.is_loading = false;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        // this.$noty.error("更新號碼區間失敗");
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.$t('models.partitions'),
                            })
                        );
                        this.is_loading = false;
                    });
            }
        }
    },
    validator: {
        target: "partition",
        localize_key: "partitions",
        input_alert: true,
        attributes: [
            {
                name: "name",
                required: true
            },
            {
                name: "customer_identity",
                required: false
            },
            {
                name: "numbers_from",
                required: true
            },
            {
                name: "numbers_to",
                required: true
            },
            {
                name: "note",
                required: false
            }
        ]
    },
    computed: {
        current_store: (instance) => instance.$store.state.provider.partitions_module,
        current_customer() {
            return _.findLast(this.current_store.customers, customer => customer.identity == this.partition.customer_identity)
        }
    },
    components: {
        FileUploader
    }
}
</script>

<style lang="scss">
</style>
